import {
	useIsWeddingsHostedCountBadgeVariant1Enabled,
	useShouldShowHostedBadge,
} from '@client/hooks/use-weddings-hosted-count-badge';
import { Icon } from '@tkww/orion-web-ds-graphic';
import { TextBody } from '@tkww/orion-web-ds-text';
import React from 'react';
import { useStorefrontHostedBadgeAnalytics } from '../../hooks/use-storefront-hosted-badge-analytics';
import Styles from './HostedBadge.scss';
import { Fire } from './icons/Fire';

export const HostedBadge = (): JSX.Element | null => {
	const hostedBadge = useShouldShowHostedBadge();
	const isVariant1 = useIsWeddingsHostedCountBadgeVariant1Enabled();

	useStorefrontHostedBadgeAnalytics();
	if (!hostedBadge) {
		return null;
	}

	const yearSuffix =
		hostedBadge.startYear && Number.isFinite(hostedBadge.startYear)
			? ` since ${hostedBadge.startYear}`
			: '';
	const copyText = `${hostedBadge.value} weddings on The Knot${yearSuffix}`;
	const icon = isVariant1 ? (
		<Fire />
	) : (
		<Icon
			aria-hidden={true}
			className={Styles.checkIcon}
			name="check-circle-filled"
			size="md"
			color="success"
			aria-label={undefined}
		/>
	);

	return (
		<div className={Styles.row} data-testid="hosted-badge">
			<span
				aria-hidden="true"
				className={Styles.icon}
				data-testid={
					isVariant1 ? 'hosted-badge-icon-fire' : 'hosted-badge-icon-check'
				}
			>
				{icon}
			</span>
			<TextBody size="md" className={Styles.copyText}>
				{copyText}
			</TextBody>
		</div>
	);
};
